import { render } from "./detail.vue?vue&type=template&id=20006e40&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=20006e40&scoped=true&lang=css"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20006e40"]])

export default __exports__